import { FC } from 'react';
import { FormInputProps } from 'features/common/components/Form/types';
import { useFormContext, get } from 'react-hook-form';
import styles from './PunchupInput.module.css';

const PunchupInput: FC<FormInputProps> = ({
	id,
	name,
	label,
	type = 'text',
	promoCodeForm: _promoCodeForm,
	disabled,
	style,
	isFromRequiredFields,
	errorProp,
	required,
	...rest
}: FormInputProps) => {
	const {
		register,
		formState: { errors, dirtyFields },
	} = useFormContext();
	// get() resolves nested paths like "recipients[0].email" that flat key lookup cannot.
	const error = get(errors, name);
	const isFieldDirty = !disabled && !!get(dirtyFields, name as string);

	const hasError = Boolean(error) || Boolean(errorProp);
	const inputClassName = [
		styles.input,
		hasError && styles.inputError,
		isFieldDirty && !hasError && styles.inputDirty,
		isFromRequiredFields && 'requiredFields',
	]
		.filter(Boolean)
		.join(' ');

	return (
		<div className={styles.container}>
			{label && (
				<label className="punchupFormLabel" htmlFor={id ?? name} data-required={required || undefined}>
					{label}
				</label>
			)}
			<input
				id={id ?? name}
				type={type}
				disabled={disabled}
				style={style}
				className={inputClassName}
				{...register(name)}
				{...rest}
			/>
			{(error?.message || errorProp) && (
				<span className="punchupFormError">{(error?.message || errorProp) as string}</span>
			)}
		</div>
	);
};

export { PunchupInput };
